/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 指定的项目相关信息缓存预热
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  productIds: Array<number>,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/good/product/pre-cache`,
    data: productIds,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
